export default 'DUCKS/PSEARCH';
